import React from 'react';
import ReactDOM from 'react-dom/client';
import MsalProvider from './components/providers/MsalProvider';
import App from './App';
import './globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MsalProvider>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
